import {Injectable, OnDestroy} from "@angular/core";
import {BaseStore} from "../../../../store/core/base-store";
import {EventAnalysisStoreService} from "../../../../store/event-analysis-store.service";
import {Table} from "../models/table/table";
import {CompositionTableHelper} from "../utils/composition-table-helper";
import {SalesRepository} from "../../../../repositories/core/sales-repository/sales-repository";
import {LinkedDtoRepository} from "../../../../../common/repositories/linked-dto-repository";
import {SalesDto} from "../../../../models/sales/sales-dto";
import {FilterKeys} from "../../../../../common/utils/filter/enums/filter-keys";
import {GroupRow} from "../models/group-row/group-row";
import {Row} from "../models/row/row";

@Injectable()
export class CompositionOverviewStore extends BaseStore implements OnDestroy {
  table: Table = new Table([])
  compositionTableHelper: CompositionTableHelper = new CompositionTableHelper()

  //isTableDataAvailable = true
  constructor(
    public eventAnalysisStoreService: EventAnalysisStoreService,
    public salesRepository: SalesRepository,
    public linkedDtoRepository: LinkedDtoRepository<any>
  ) {
    super(eventAnalysisStoreService);

    // #534: what a ROW is changes with the "Kombinationen einzeln" mode, so the skeleton itself has to be
    // rebuilt — re-aggregating on the old rows would keep every swap merged (or split rows the data no longer
    // fills). The store service emits this BEFORE its update, so the update that follows lands on fresh rows.
    this.subscription.add(this.eventAnalysisStoreService.groupingModeNotifier.subscribe(() => this.initialize()))
  }

  override initialize() {
    this.compositionTableHelper.setFilterHelper(this.salesRepository.filterHelper)
    this.table = CompositionTableHelper.createTableRowTemplate(
      this.salesRepository.getSalesWrapper(),
      this.salesRepository.getCachedSalesWrapper(),
      (key: SalesDto) => key["compositionTypeId"],
      (key: string) => this.linkedDtoRepository.getName(key, "compositionTypeId"),
      this.linkedDtoRepository,
      this.eventAnalysisStoreService.compositionRowKeyFn(),
      this.eventAnalysisStoreService.compositionRowKey())
    this.compositionTableHelper.sortTable(this.table)
  }

  override update() {
    this.getCompositionTypeTableData(this.table)
  }

  getCompositionTypeTableData(table: Table): Table {
    CompositionTableHelper.processDataForTable(this.salesRepository.getSalesWrapper(), table, (baseOrderElement) => baseOrderElement.compositionTypeId, this.eventAnalysisStoreService.compositionRowKeyFn());
    return table
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }

  isFilterActive(key: FilterKeys, value: string | number | undefined) {
    return this.salesRepository.filterHelper.isFilterActive(key, value)

  }

  /**
   * The filter key the row checkboxes currently work on — `compositionId` in combined mode,
   * `compositionVariantKey` while "Kombinationen einzeln" is on. The template reads it too, so the checked
   * state is asked about the same key it was written under (#534).
   */
  compositionFilterKey(): FilterKeys {
    return this.eventAnalysisStoreService.compositionRowFilterKey()
  }

  /** `true` while rows are one-per-swap-combination — drives the sub-line rendering. */
  isIndividualGrouping(): boolean {
    return this.eventAnalysisStoreService.groupingMode() === 'individual'
  }

  filterCompositionType(groupRow: GroupRow): void {
    CompositionTableHelper.filterCompositionType(this.eventAnalysisStoreService, groupRow, this.compositionFilterKey())
  }

  filterComposition(groupRow: GroupRow, row: Row): void {
    CompositionTableHelper.filterComposition(this.eventAnalysisStoreService, this.salesRepository.filterHelper, groupRow, row, this.compositionFilterKey())
  }

  getTable() {
    return this.table
  }

}
